// Copyright 2020 Drivetrain Hub LLC
// GraphQL request helpers for engineering data.

// region QUERY SCHEMA

// region TOOLING

const BasicRackCompute = `
  rootRadiusCoefficient`;

const RackCutterCompute = `
  tipRadiusCoefficient`;

const HobCompute = `
  tipRadiusCoefficient`;

const PinionCutterCompute = `
  tipRadiusCoefficient
  ttrRCenter
  ttrLambdaCenter
  ttrThetaProfileTangent
  ttrThetaEndTangent
  ttrThetaEoi
  rollAngleEoi`;

// endregion

// region GEARING

// region PROPERTIES

const MaterialDataAGMA2001_D04 = `
  Id
  designation
  heatTreatment
  grade
  surfaceHardnessMin
  surfaceHardnessScale
  coreHardnessMin
  coreHardnessScale
  coreHardnessVariable
  allowableStressContactMin
  allowableStressBendingMin`;

const MaterialDataISO6336_5_2003 = `
  Id
  abbreviation
  type
  quality
  surfaceHardnessScale
  surfaceHardnessMin
  surfaceHardnessMax
  coreHardnessScale
  coreHardnessMin
  allowableStressContactMin
  nominalStressBendingMin
  aContact
  bContact
  aBending
  bBending`;

const QualityDataAGMA1328_1_B14 = `
  toleranceClass
  sectorPitches
  singlePitchTolerance
  cumulativePitchTolerance
  sectorPitchTolerance
  adjacentPitchDifferenceTolerance
  profileSlopeTolerance
  profileFormTolerance
  totalProfileTolerance
  helixSlopeTolerance
  helixFormTolerance
  totalHelixTolerance
  runoutTolerance`;

const QualityDataAGMA2015_2_B15 = `
  toleranceClass
  sectorPitches
  radialCompositeToleranceTooth2tooth
  radialCompositeToleranceTotal
  radialCompositeToleranceK`;

const QualityDataISO1328_1_2013 = `
  toleranceClass
  sectorPitches
  singlePitchTolerance
  cumulativePitchTolerance
  sectorPitchTolerance
  adjacentPitchDifferenceTolerance
  profileSlopeTolerance
  profileFormTolerance
  totalProfileTolerance
  helixSlopeTolerance
  helixFormTolerance
  totalHelixTolerance
  runoutTolerance`;

const QualityDataISO1328_2_2020 = `
  toleranceClass
  sectorPitches
  radialCompositeToleranceTooth2tooth
  radialCompositeToleranceTotal
  radialCompositeToleranceK`;

// endregion

// region RATINGS - ISO

const StressLimitISO6336_2_2006 = `
  loadCycles
  lifeFactor
  lubricantFactor
  velocityFactor
  roughnessFactor
  workHardeningFactor
  sizeFactor
  pittingStressLimit`;

const stressLimitsIso633622006 = `
  static {${StressLimitISO6336_2_2006}}
  limitedLife1 {${StressLimitISO6336_2_2006}}
  limitedLife2 {${StressLimitISO6336_2_2006}}
  longLifeGeneral {${StressLimitISO6336_2_2006}}
  longLifeCritical {${StressLimitISO6336_2_2006}}`;

const StressLimitISO6336_3_2006 = `
  loadCycles
  lifeFactor
  stressCorrectionFactor
  relativeNotchSensitivityFactor
  relativeSurfaceFactor
  sizeFactor
  toothRootStressLimit`;

const stressLimitsIso633632006 = `
  static {${StressLimitISO6336_3_2006}}
  limitedLife {${StressLimitISO6336_3_2006}}
  longLifeGeneral {${StressLimitISO6336_3_2006}}
  longLifeCritical {${StressLimitISO6336_3_2006}}`;

// endregion

// region RATINGS - AGMA

const StressLimitsPittingAGMA2001_D04 = `
  loadCycles
  stressCycleFactor
  hardnessRatioFactor
  temperatureFactor
  reliabilityFactor
  pittingStressLimit`;

const stressLimitsPittingAgma2001D04 = `
  static {${StressLimitsPittingAGMA2001_D04}}
  limitedLife {${StressLimitsPittingAGMA2001_D04}}
  longLifeGeneral {${StressLimitsPittingAGMA2001_D04}}
  longLifeCritical {${StressLimitsPittingAGMA2001_D04}}`;

const StressLimitBendingAGMA2001_D04 = `
  loadCycles
  stressCycleFactor
  temperatureFactor
  reliabilityFactor
  bendingStressLimit`;

const stressLimitsBendingAgma2001D04 = `
  static {${StressLimitBendingAGMA2001_D04}}
  limitedLife {${StressLimitBendingAGMA2001_D04}}
  longLifeGeneral {${StressLimitBendingAGMA2001_D04}}
  longLifeCritical {${StressLimitBendingAGMA2001_D04}}`;

// endregion

// region TOOTH DATA

const RootParams = `
  x
  y
  filletBoundaryCutAngle
  filletBoundaryDiameter
  protuberanceBoundaryDiameter
  protuberanceBaseDiameter`;

const ToothFinishedRootParams = `
  finishedRoot {
    ${RootParams}
  }`;

const ToothFinishedParams = `
  finishedParams
  finishedRoot {
    ${RootParams}
  }
`;

const finishedToothQueryStr = `
  tooth {
    ${ToothFinishedParams}
  }
`;

// endregion

// endregion

// endregion

// region MUTATION INPUTS

// endregion

// region QUERIES

// endregion

export default {
  // TOOLING
  BasicRackCompute: BasicRackCompute,
  RackCutterCompute: RackCutterCompute,
  HobCompute: HobCompute,
  PinionCutterCompute: PinionCutterCompute,
  // PROPERTIES
  MaterialDataAGMA2001_D04: MaterialDataAGMA2001_D04,
  MaterialDataISO6336_5_2003: MaterialDataISO6336_5_2003,
  QualityDataAGMA1328_1_B14: QualityDataAGMA1328_1_B14,
  QualityDataAGMA2015_2_B15: QualityDataAGMA2015_2_B15,
  QualityDataISO1328_1_2013: QualityDataISO1328_1_2013,
  QualityDataISO1328_2_2020: QualityDataISO1328_2_2020,
  // RATINGS
  stressLimitsIso633622006: stressLimitsIso633622006,
  stressLimitsIso633632006: stressLimitsIso633632006,
  stressLimitsPittingAgma2001D04: stressLimitsPittingAgma2001D04,
  stressLimitsBendingAgma2001D04: stressLimitsBendingAgma2001D04,
  // GEAR GEOMETRY
  RootParams: RootParams,
  ToothFinishedRootParams: ToothFinishedRootParams,
  ToothFinishedParams: ToothFinishedParams,
  finishedToothQueryStr: finishedToothQueryStr,
}
